<script>
import baseMixin from '@/mixins/baseMixin'
import BookingListTabKey from '@/shared/constants/booking/BookingListTabKey'
import CustomTooltip from '@/components/booking/bookingList/custom-tooltip.vue'

export default {
  name: 'DateColumn',
  components: {
    CustomTooltip,
  },
  mixins: [baseMixin],
  props: {
    booking: { type: Object, default: null },
    currentTabName: { type: String, required: true },
    activeTab: { type: [String, Number], default: '' },
    bookingTime: { type: String, default: '' },
    isDayByDay: { type: Boolean, default: false },
    blockRange: { type: Object, default: null },
    blockTimes: { type: Object, default: null },
    viewSidepanel: { type: Function, required: true },
  },
  data() {
    return {
      BookingListTabKey,
    }
  },
  methods: {
    formatShortDate(dateStrOrDate) {
      const date =
        dateStrOrDate instanceof Date ? dateStrOrDate : new Date(dateStrOrDate)
      if (isNaN(date)) return ''
      const day = String(date.getDate()).padStart(2, '0')
      const wk = date.toLocaleDateString('en-US', { weekday: 'short' })
      const mon = date.toLocaleDateString('en-US', { month: 'short' })
      return `${day} ${wk}, ${mon}`
    },
    getDayNumber(dateStr) {
      const date = new Date(dateStr)
      if (isNaN(date)) return ''
      return date.getDate()
    },
    getDayAndMonth(dateStr) {
      const date = new Date(dateStr)
      if (isNaN(date)) return dateStr
      const dayName = date.toLocaleDateString('en-US', { weekday: 'short' })
      const monthName = date.toLocaleDateString('en-US', { month: 'short' })
      return `${dayName}, ${monthName}`
    },
  },
}
</script>

<template>
  <td class="date-cell" @click.stop="viewSidepanel(booking)">
    <!-- DATE (range) - desktop -->
    <template
      v-if="
        !isMobile &&
          (!activeTab || currentTabName === BookingListTabKey.approvalRequired)
      "
    >
      <div class="h-full d-flex">
        <span class="day-label">
          <!-- Day-by-day booking's single-day range -->
          <template v-if="isDayByDay">
            <span class="start-date">{{
              formatShortDate(booking.startDateTimeLocal)
            }}</span>
            –
            <span class="end-date">{{
              formatShortDate(booking.endDateTimeLocal)
            }}</span>
          </template>
          <!-- Block earliest start – latest end (short) -->
          <template v-else-if="blockRange">
            <span class="start-date">{{
              formatShortDate(blockRange.minStart)
            }}</span>
            –
            <span class="end-date">{{
              formatShortDate(blockRange.maxEnd)
            }}</span>
          </template>
        </span>
      </div>
    </template>
    <!-- DATE (day number + label) - desktop (day-by-day only) -->
    <template v-else-if="!isMobile">
      <span class="day-number">{{
        getDayNumber(booking.startDateTimeLocal)
      }}</span>
      <span class="day-label">{{
        getDayAndMonth(booking.startDateTimeLocal)
      }}</span>
    </template>
    <!-- DATE (mobile layout) -->
    <template v-if="isMobile">
      <div
        class="d-flex flex-row align-items-center justify-content-center gap-2"
      >
        <span v-if="isDayByDay" class="day-number mt-1 me-5 ms-2">
          {{ getDayNumber(booking.startDateTimeLocal) }}
        </span>
        <div class="d-flex flex-column text-start">
          <span v-if="!isDayByDay" class="day-label mt-1 me-5">
            {{ formatShortDate(blockRange.minStart) }} –
            {{ formatShortDate(blockRange.maxEnd) }}
          </span>
          <span v-else class="day-label">
            {{ getDayAndMonth(booking.startDateTimeLocal) }}
          </span>
          <span class="day-label">
            <template v-if="isDayByDay">
              {{ bookingTime }}
            </template>
            <template v-else-if="blockRange">
              <template v-if="booking.timeVaries">
                <div class="times-vary">
                  <CustomTooltip :text="blockTimes.variations">
                    {{ $t('bookingList.timesVary') }}
                  </CustomTooltip>
                </div>
              </template>
              <template v-else
                >{{ blockTimes.start }} - {{ blockTimes.end }}</template
              >
            </template>
          </span>
        </div>
      </div>
    </template>
  </td>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-row.scss';
</style>
